/**
 * User companies API operations
 */
import { get, post } from './base';

export interface UserCompany {
  id: string;
  name: string;
}

/**
 * Get all companies for the current user
 */
export const getUserCompanies = async (): Promise<UserCompany[]> => {
  const response = await get<UserCompany[]>('/user/companies/');
  return response ?? [];
};

/**
 * Switch to a different company
 */
export const switchCompany = async (
  companyId: string
): Promise<{ company_id: string; company_name: string }> => {
  return post<{ company_id: string; company_name: string }>('/company/switch/', {
    company_id: companyId,
  });
};

/**
 * Get current active company
 */
export const getCurrentCompany = async (): Promise<{ id: string; name: string }> => {
  return get<{ id: string; name: string }>('/company/current/');
};
